module.exports = __webpack_public_path__ + "static/media/listing-page-srinagar.26072708.jpg";